export var name = /^[a-zA-Z_$][a-zA-Z_$0-9]*/;
